/** French (`fr`) catalog. */
export const catalogFr: Record<string, string> = {
  "quiz.account.menu_aria_label": "Compte et déconnexion",
  "quiz.account.pending_summary": "Compte",
  "quiz.home.checking_session": "Vérification de votre connexion...",
  "quiz.home.cta_continue_my_quizzes": "Continuer vers Mes quiz",
  "quiz.home.cta_create_quiz_primary": "Créer un quiz",
  "quiz.home.cta_sign_in_organizer": "Connexion",
  "quiz.home.footer_aux_aria_label": "Liens juridiques et aide",
  "quiz.home.footer_legal": "© {year} Quiz. Tous droits réservés.",
  "quiz.home.footer_link_contact": "Nous contacter",
  "quiz.home.footer_link_help": "Centre d'aide",
  "quiz.home.footer_link_privacy": "Politique de confidentialité",
  "quiz.home.footer_link_terms": "Conditions d'utilisation",
  "quiz.home.header_sign_in": "Connexion",
  "quiz.home.header_title": "Quiz",
  "quiz.home.hero_signed_in_generic": "Bon retour",
  "quiz.home.hero_signed_in_named": "Bonjour, {name}",
  "quiz.home.hero_signed_in_subtitle":
    "Créez et gérez des quiz pour vos sessions de formation.",
  "quiz.home.hero_subtitle":
    "Invitez les participants par e-mail. Ils étudient et passent les tests.",
  "quiz.home.hero_title": "Quiz de formation créés à partir de vos documents",
  "quiz.home.label_display_name": "Nom affiché",
  "quiz.home.label_user_id": "ID utilisateur",
  "quiz.home.link_my_quizzes": "Mes quiz",
  "quiz.home.link_view_existing_quizzes": "Parcourir les quiz existants",
  "quiz.home.link_new_training_quiz":
    "Démarrer l'assistant configuré (recommandé)",
  "quiz.home.logout": "Se déconnecter",
  "quiz.home.logout_failed": "Échec de la déconnexion. Réessayez.",
  "quiz.home.logout_pending": "Déconnexion en cours...",
  "quiz.home.participant_guidance_body":
    "Les participants recevront par e-mail un lien vers le quiz.",
  "quiz.home.participant_guidance_summary":
    "Comment les participants rejoignent",
  "quiz.home.role_organizers_bullet_1": "Téléverser du matériel.",
  "quiz.home.role_organizers_bullet_2":
    "Générer le pool de questions et envoyer les invitations.",
  "quiz.home.role_organizers_title": "Organisateurs",
  "quiz.home.role_participants_bullet_1": "Utiliser le lien dans l'e-mail.",
  "quiz.home.role_participants_bullet_2": "Complétez le quiz.",
  "quiz.home.role_participants_title": "Participants",
  "quiz.home.session_error": "Impossible de lire l'état de connexion.",
  "quiz.home.signed_in_title": "Compte",
  "quiz.home.skip_to_main": "Aller au contenu principal",
  "quiz.my_quizzes.title": "Mes quiz",
  "quiz.my_quizzes.loading": "Chargement des quiz...",
  "quiz.my_quizzes.empty":
    "Pas encore de brouillons. Créez-en un pour ajouter du matériel. Le nom peut venir du premier fichier importé ; modifiez-le ici avant publication.",
  "quiz.my_quizzes.feature_off":
    "Les quiz de formation ne sont pas activés sur ce déploiement.",
  "quiz.my_quizzes.sign_in_required": "Connectez-vous pour gérer les quiz.",
  "quiz.my_quizzes.load_failed": "Impossible de charger les quiz.",
  "quiz.my_quizzes.create_submit": "Créer un quiz",
  "quiz.my_quizzes.create_failed":
    "Impossible de créer le brouillon. Réessayez.",
  "quiz.my_quizzes.quiz_title_field": "Titre du quiz",
  "quiz.my_quizzes.save_title": "Enregistrer le titre",
  "quiz.my_quizzes.untitled_placeholder":
    "Sans titre — depuis le premier fichier ou saisie",
  "quiz.my_quizzes.title_save_failed":
    "Impossible d'enregistrer le titre. Réessayez.",
  "quiz.my_quizzes.quiz_status_draft": "Brouillon",
  "quiz.my_quizzes.quiz_status_published": "Publié",
  "quiz.my_quizzes.quiz_status_other": "{status}",
  "quiz.my_quizzes.summary_with_pipeline": "{lifecycle} · {pipeline}",
  "quiz.my_quizzes.generation_phase_running": "Génération des questions",
  "quiz.my_quizzes.generation_phase_failed": "Échec de la génération",
  "quiz.my_quizzes.generation_phase_queued": "Génération en file d'attente",
  "quiz.my_quizzes.generation_phase_other": "{phase}",
  "quiz.my_quizzes.created_line": "Créé le {date}",
  "quiz.my_quizzes.loading_more": "Chargement…",
  "quiz.detail.back_my_quizzes": "Retour à Mes quiz",
  "quiz.detail.loading": "Chargement du quiz...",
  "quiz.detail.sign_in_required": "Connectez-vous pour voir ce quiz.",
  "quiz.detail.not_found": "Quiz introuvable ou accès refusé.",
  "quiz.detail.load_failed": "Impossible de charger le quiz.",
  "quiz.detail.recipients_failed":
    "Impossible de charger la liste des destinataires.",
  "quiz.detail.created_line": "Créé le {date}",
  "quiz.detail.quiz_id_line": "ID du quiz : {quiz_id}",
  "quiz.detail.status_line": "Statut du quiz : {status}",
  "quiz.detail.title_edit_aria": "Modifier le titre du quiz",
  "quiz.detail.title_edit_glyph": "\u270E",
  "quiz.detail.title_confirm_aria": "Enregistrer le titre",
  "quiz.detail.title_confirm_glyph": "\u2713",
  "quiz.detail.title_cancel_aria": "Annuler la modification du titre",
  "quiz.detail.title_cancel_glyph": "\u2715",
  "quiz.detail.open_wizard_add_recipients":
    "Ouvrir l'assistant pour ajouter des destinataires ou envoyer des invitations",
  "quiz.detail.pool_heading": "Banque de questions",
  "quiz.detail.pool_summary":
    "Actives : {active}. Total enregistré : {total}. Inactives (non tirées) : {inactive}.",
  "quiz.detail.pool_empty": "Aucune question active dans la banque.",
  "quiz.detail.roster_heading": "Candidats",
  "quiz.detail.roster_empty": "Aucune affectation pour l'instant.",
  "quiz.detail.roster_empty_hint_wizard":
    "Ouvrir l'assistant pour inviter des personnes.",
  "quiz.detail.col_email": "E-mail",
  "quiz.detail.col_invitation": "Invitation",
  "quiz.detail.col_attempt": "Tentative",
  "quiz.detail.col_completed": "Terminé le",
  "quiz.detail.col_invite": "Lien",
  "quiz.detail.completed_dash": "-",
  "quiz.detail.invitation_sent": "Envoyée",
  "quiz.detail.invitation_not_sent": "Non envoyée",
  "quiz.detail.attempt_pass": "Réussi",
  "quiz.detail.attempt_fail": "Échoué",
  "quiz.detail.attempt_in_progress": "En cours",
  "quiz.detail.attempt_not_submitted": "Non commencé",
  "quiz.detail.transcript_open_aria":
    "Ouvrir le relevé de test soumis pour {email}",
  "quiz.detail.transcript_title": "Relevé de test",
  "quiz.detail.transcript_close": "Fermer",
  "quiz.detail.transcript_fullscreen": "Page entière",
  "quiz.detail.transcript_fullscreen_aria":
    "Ouvrir ce relevé sur une page dédiée",
  "quiz.detail.transcript_back_to_quiz": "Retour au test",
  "quiz.detail.transcript_loading": "Chargement du relevé…",
  "quiz.detail.transcript_error": "Impossible de charger le relevé.",
  "quiz.detail.transcript_meta_line": "{email} · {date}",
  "quiz.detail.transcript_attempt_id": "ID de tentative : {id}",
  "quiz.detail.transcript_outcome_passed": "Résultat : Réussi",
  "quiz.detail.transcript_outcome_failed": "Résultat : Échoué",
  "quiz.detail.transcript_score": "Score : {percent} %",
  "quiz.detail.transcript_selected_option": "Réponse donnée : {text}",
  "quiz.detail.transcript_correct_option": "Bonne réponse : {text}",
  "quiz.detail.transcript_no_selection": "(Aucune réponse enregistrée)",
  "quiz.detail.transcript_mark_correct": "Marqué correct",
  "quiz.detail.transcript_mark_incorrect": "Marqué incorrect",
  "quiz.detail.transcript_signing_area_aria":
    "Zone de signature (réservée aux signatures manuscrites après impression)",
  "quiz.detail.get_invite_link": "Obtenir le lien",
  "quiz.detail.invite_link_confirm":
    "Créer un nouveau lien d'invitation ? Les liens précédents pour cette affectation cessent de fonctionner.",
  "quiz.detail.invite_link_copied":
    "Lien d'invitation copié dans le presse-papiers.",
  "quiz.detail.invite_link_manual_copy": "Copiez ce lien d'invitation :",
  "quiz.detail.invite_link_failed": "Impossible d'obtenir le lien. Réessayez.",
  "quiz.detail.invite_link_no_origin":
    "Cette instance ne peut pas construire de lien (URL publique manquante). Demandez à l'opérateur de définir QUIZ_INVITE_PUBLIC_ORIGIN.",
  "quiz.detail.choice_correct": "Correct : {text}",
  "quiz.wizard.page_title": "Configuration quiz de formation",
  "quiz.wizard.back_my_quizzes": "Mes quiz",
  "quiz.wizard.progress": "Étape {step} sur {total}",
  "quiz.wizard.intro_lead":
    "Nom, aperçu des envois et de la génération, destinataires puis envoi.",
  "quiz.wizard.create_draft_button": "Créer un brouillon et commencer",
  "quiz.wizard.create_failed": "Échec de la création du brouillon.",
  "quiz.wizard.loading_quiz": "Chargement du quiz...",
  "quiz.wizard.quiz_missing": "Quiz introuvable.",
  "quiz.wizard.need_sign_in": "Reconnectez-vous depuis la page d'accueil.",
  "quiz.wizard.preview_note":
    "Génération, pool et publication suivent les APIs. SES via QUIZ_SES_MAIL_FROM. Stockage matériel : bucket opérateur (QUIZ_MATERIAL_BUCKET).",
  "quiz.wizard.step_title_name": "Intitulé du quiz",
  "quiz.wizard.step_title_help":
    "Pourra être rempli via fichiers ; affinez pour les invités.",
  "quiz.wizard.save_title_continue": "Enregistrer et continuer",
  "quiz.wizard.step_training_heading": "Matériel de formation",
  "quiz.wizard.step_training_body":
    "Importez jusqu'à trois fichiers .txt (texte brut UTF-8), .pdf ou .xlsx. Attendez Prêt pour tous, puis Continuer. Les PDF numérisés sans texte intégré peuvent donner peu ou pas de texte extrait.",
  "quiz.wizard.step_generation_heading":
    "Paramètres de génération et pool de questions",
  "quiz.wizard.step_generation_body":
    "Definissez le nombre de questions par tentative et la forme des reponses, puis generez des QCM brouillon a partir de vos fichiers prets. Ajustez le pool jusqu'a avoir assez de questions actives, puis continuez.",
  "quiz.wizard.generation_pipeline_status": "Pipeline de génération : {status}",
  "quiz.wizard.generation_settings_heading": "Parametres de generation",
  "quiz.wizard.generation_settings_hint":
    "Les valeurs par defaut conviennent a la plupart des quiz.",
  "quiz.wizard.generation_questions_per_attempt_label": "Questions par quiz",
  "quiz.wizard.generation_pool_count_label": "Taille du pool de questions",
  "quiz.wizard.generation_pool_count_hint":
    "Par defaut, le double du nombre de questions par quiz ; chaque utilisateur recoit un echantillon aleatoire.",
  "quiz.wizard.generation_shape_heading": "Forme des questions",
  "quiz.wizard.generation_option_count_label": "Reponses par question",
  "quiz.wizard.generation_min_correct_label": "Minimum de bonnes reponses",
  "quiz.wizard.generation_max_correct_label": "Maximum de bonnes reponses",
  "quiz.wizard.generation_shape_invalid":
    "Corrigez la forme : il faut 1 <= minimum de bonnes reponses <= maximum <= reponses par question.",
  "quiz.wizard.generation_single_correct_note":
    "La generation automatique produit encore une seule bonne reponse pleinement correcte par question.",
  "quiz.wizard.generation_config_label":
    "Paramètres JSON optionnels (fusion dans la configuration du quiz)",
  "quiz.wizard.generation_config_placeholder": "{}",
  "quiz.wizard.generation_queue_button": "Mettre en file la génération",
  "quiz.wizard.generation_busy": "Envoi…",
  "quiz.wizard.generation_json_invalid": "JSON objet invalide.",
  "quiz.wizard.generation_failed": "Impossible de mettre en file.",
  "quiz.wizard.generation_material_not_ready":
    "Tous les fichiers doivent afficher l'état Prêt.",
  "quiz.wizard.generation_locked": "Quiz verrouillé après publication.",
  "quiz.wizard.generation_queued":
    "Génération en file. Éditez le pool ci-dessous puis continuez.",
  "quiz.wizard.generation_completed_failed":
    "Le serveur a marqué cette tentative comme ayant échoué.",
  "quiz.wizard.generation_done_reload": "Génération terminée — pool actualisé.",
  "quiz.wizard.generation_failed_banner":
    "Dernière génération en échec. Corrigez extraits ou JSON (QUIZ_BEDROCK_MODEL_ID pour Bedrock) puis réessayez.",
  "quiz.wizard.generation_running_notice":
    "Génération depuis les extraits READY — courte attente.",
  "quiz.wizard.generation_reset_hint":
    "Après la limite Lambda plus une marge (souvent quelques minutes), réinitialisez si l’état reste « en cours ». Ne le faites pas si la génération progresse vraiment.",
  "quiz.wizard.generation_reset_stuck_button":
    "Reinitialiser la generation bloquee",
  "quiz.wizard.generation_reset_busy": "Reinitialisation…",
  "quiz.wizard.generation_reset_failed": "Reinitialisation impossible.",
  "quiz.wizard.generation_reset_too_soon":
    "La génération est peut-être encore en cours sur le serveur. Attendez quelques minutes, puis réessayez ou rechargez.",
  "quiz.wizard.pool_readonly_while_running":
    "Édition pausée tant que la génération est en cours.",
  "quiz.wizard.pool_edit": "Modifier",
  "quiz.wizard.pool_save_edit": "Enregistrer",
  "quiz.wizard.pool_cancel_edit": "Annuler",
  "quiz.wizard.generation_in_progress_blocked":
    "Une génération est déjà en cours pour ce quiz.",
  "quiz.wizard.generation_continue_blocked": "Mettez d'abord en file.",
  "quiz.wizard.generation_continue_blocked_pool":
    "Pas assez de questions actives pour questions_per_attempt ; complétez le pool.",
  "quiz.wizard.pool_section_title": "Pool de questions brouillon",
  "quiz.wizard.pool_section_help":
    "Chaque élément exige exactement {n, plural, one {# option} other {# options}} (option_count dans la configuration, quatre par défaut).",
  "quiz.wizard.pool_empty":
    "Aucune question brouillon. Ajoutez au moins une ci-dessous.",
  "quiz.wizard.pool_stem_placeholder":
    "Texte de la question pour les participants",
  "quiz.wizard.pool_choice_label": "Option {n}",
  "quiz.wizard.pool_correct_label":
    "Bonne option (position 1-based dans la liste)",
  "quiz.wizard.pool_correct_multi_hint":
    "Mark every choice that should count as correct (within the minimum and maximum you set in generation settings).",
  "quiz.wizard.pool_choices_aria": "Options de reponse",
  "quiz.wizard.pool_correct_option_mark": "Correct",
  "quiz.wizard.pool_item_meta":
    "{count, plural, one {# option} other {# options}}; position correcte {pos}",
  "quiz.wizard.pool_inactive_marker": "(inactive)",
  "quiz.wizard.pool_delete": "Supprimer",
  "quiz.wizard.pool_add_aria": "Ajouter une question",
  "quiz.wizard.pool_add_button": "Ajouter une question",
  "quiz.wizard.pool_busy": "Enregistrement du pool…",
  "quiz.wizard.pool_failed":
    "Échec de mise à jour du pool. Vérifiez les champs.",
  "quiz.wizard.pool_validation": "Remplissez l'intitulé et chaque option.",
  "quiz.wizard.pool_publish_hint":
    "Questions actives : {active}. Il en faut au moins {needed} selon la configuration.",
  "quiz.wizard.publish_pool_too_small":
    "Pool actif plus petit que questions_per_attempt. Revenez à l'étape 3 pour ajouter des questions.",
  "quiz.wizard.step_invite_heading": "Destinataires",
  "quiz.wizard.step_invite_body":
    "Une adresse par ligne ; dédoublonnage ; max 20.",
  "quiz.wizard.recipients_label": "Adresses e-mail",
  "quiz.wizard.recipients_placeholder":
    "person1@organisation.org\nperson2@organisation.org",
  "quiz.wizard.recipients_hint": "Ignore ligne vide; sans doublons; 20 max.",
  "quiz.wizard.publish_button": "Publier et envoyer",
  "quiz.wizard.publish_failed":
    "Échec de la publication ; vérifiez les adresses.",
  "quiz.wizard.publish_conflict": "Quiz déjà publié.",
  "quiz.wizard.publish_validation": "Adresses invalides après nettoyage.",
  "quiz.wizard.back_step": "Retour",
  "quiz.wizard.continue": "Continuer",
  "quiz.wizard.success_title": "Invitations enregistrées",
  "quiz.wizard.success_lead_publish":
    "Affectations créées ; livraison SES selon la configuration.",
  "quiz.wizard.success_lead_repeat":
    "Invitations enregistrées : {count, plural, one {#} other {#}}.",
  "quiz.wizard.mail_notice_ses_optional":
    "SES envoie lorsque QUIZ_SES_MAIL_FROM est actif.",
  "quiz.wizard.mail_notice_skipped":
    "SES ignoré ici ; ajoutez IAM/identités pour la production.",
  "quiz.wizard.mail_sent": "Envoyé",
  "quiz.wizard.mail_failed": "Échec d'envoi",
  "quiz.wizard.mail_skipped": "Ignoré (sans SES)",
  "quiz.wizard.col_email": "Destinataire",
  "quiz.wizard.col_delivery": "Statut mail",
  "quiz.wizard.back_to_my_quizzes": "Vers Mes quiz",
  "quiz.wizard.view_quiz_detail": "Voir le détail du quiz",
  "quiz.wizard.material_docs_heading": "Fichiers chargés",
  "quiz.wizard.material_empty": "Aucun fichier — ajoutez au moins un document.",
  "quiz.wizard.material_upload_pick":
    "Choisir un fichier (.txt, .pdf, .docx, .xlsx)",
  "quiz.wizard.material_choose_file": "Choisir un fichier",
  "quiz.wizard.material_drop_aria":
    "Ajouter des documents de formation en les déposant ici ou via le sélecteur de fichiers",
  "quiz.wizard.material_drop_hint":
    "Déposez les fichiers ici (.txt, .pdf, .docx, .xlsx) ou",
  "quiz.wizard.material_busy": "Transfert…",
  "quiz.wizard.material_no_file": "Choisissez d'abord un fichier.",
  "quiz.wizard.material_failed": "Échec de l'import. Réessayez.",
  "quiz.wizard.material_put_failed": "Échec de l'envoi direct au stockage.",
  "quiz.wizard.material_storage_off":
    "Stockage absent sur ce déploiement (QUIZ_MATERIAL_BUCKET).",
  "quiz.wizard.material_limit": "Nombre maximal de documents atteint.",
  "quiz.wizard.material_next_blocked":
    "Continuer seulement quand tout affiche Prêt.",
  "quiz.wizard.material_delete_aria": "Retirer le fichier",
  "quiz.wizard.material_remove_failed":
    "Impossible de retirer le fichier. Réessayez.",
  "quiz.wizard.material_state_AWAITING_BYTES": "En attente",
  "quiz.wizard.material_state_INGESTING": "Traitement",
  "quiz.wizard.material_state_READY": "Prêt",
  "quiz.wizard.material_state_FAILED": "Échec",
  "quiz.health.heading": "Santé du backend",
  "quiz.health.loading": "Appel GET /api/v1/health...",
  "quiz.health.httpStatus": "Statut HTTP : {status}",
  "quiz.health.responseBody": "Corps de la réponse",
  "quiz.health.networkError": "Impossible d'atteindre l'API.",
  "quiz.health.notJson": "La réponse n'était pas du JSON valide.",
  "quiz.organizer.sign_in.title": "Connexion",
  "quiz.organizer.sign_in.lead": "Choisissez un fournisseur pour continuer.",
  "quiz.organizer.sign_in.google": "Continuer avec Google",
  "quiz.organizer.sign_in.github": "Continuer avec GitHub",
  "quiz.organizer.sign_in.bootstrap.heading":
    "Identifiants opérateur (environnement)",
  "quiz.organizer.sign_in.bootstrap.lead":
    "Pour un accès d'urgence lorsque OAuth est indisponible.",
  "quiz.organizer.sign_in.bootstrap.username_label": "Nom d'utilisateur",
  "quiz.organizer.sign_in.bootstrap.password_label": "Mot de passe",
  "quiz.organizer.sign_in.bootstrap.submit": "Se connecter",
  "quiz.organizer.sign_in.nav_home": "Accueil",
  "quiz.components.button.sample_label": "Continuer",
  "quiz.components.button.danger_sample": "Supprimer",
  "quiz.components.icon_button.sample_aria": "Actions supplémentaires",
  "quiz.components.icon_button.sample_glyph": "+",
  "quiz.ui_demo.heading": "Bibliothèque de composants UI",
  "quiz.ui_demo.lead":
    "Présentation statique des contrôles quiz-frontend partagés entre les routes.",
  "quiz.ui_demo.subheading_buttons": "Boutons",
  "quiz.ui_demo.caption_enabled": "Primaire actif",
  "quiz.ui_demo.caption_disabled": "Primaire désactivé",
  "quiz.ui_demo.caption_app_link": "Lien texte",
  "quiz.ui_demo.caption_btn_danger": "Bouton danger",
  "quiz.ui_demo.caption_btn_ghost": "Bouton fantôme",
  "quiz.ui_demo.caption_btn_secondary": "Bouton secondaire contour",
  "quiz.ui_demo.caption_icon_btn": "Bouton icône",
  "quiz.ui_demo.caption_layout_card": "Surface carte",
  "quiz.ui_demo.caption_layout_headings": "Échelle de titres",
  "quiz.ui_demo.caption_layout_stack": "Pile verticale",
  "quiz.ui_demo.caption_layout_text": "Corps et texte atténué",
  "quiz.ui_demo.sample_app_link_label": "Ouvrir la page santé du backend",
  "quiz.ui_demo.sample_card_body": "Exemple de contenu dans la carte.",
  "quiz.ui_demo.sample_heading_h3": "Titre de niveau trois",
  "quiz.ui_demo.sample_heading_h4": "Titre de niveau quatre",
  "quiz.ui_demo.sample_text_body": "Texte principal pour les descriptions.",
  "quiz.ui_demo.sample_text_muted": "Texte d'aide atténué.",
  "quiz.ui_demo.skip_to_main": "Aller au contenu principal",
  "quiz.ui_demo.stack_line_one": "Ligne de pile un",
  "quiz.ui_demo.stack_line_two": "Ligne de pile deux",
  "quiz.ui_demo.subheading_forms": "Formulaires",
  "quiz.ui_demo.subheading_layout": "Mise en page et typographie",
  "quiz.ui_demo.caption_field_file": "Fichier avec étiquette",
  "quiz.ui_demo.caption_field_radio": "Groupe de boutons radio",
  "quiz.ui_demo.caption_field_select": "Liste déroulante",
  "quiz.ui_demo.caption_field_text": "Texte avec aide",
  "quiz.ui_demo.caption_field_text_invalid": "Texte avec erreur",
  "quiz.ui_demo.caption_field_textarea": "Zone de texte",
  "quiz.ui_demo.caption_checkbox": "Case à cocher",
  "quiz.ui_demo.forms_error_required": "Le nom est obligatoire.",
  "quiz.ui_demo.forms_file_hint": "Accepte seulement .txt pour la démo.",
  "quiz.ui_demo.forms_hint_name":
    "Utilisé comme nom affiché sur les formulaires.",
  "quiz.ui_demo.forms_label_agree": "J'accepte les conditions de démo",
  "quiz.ui_demo.forms_label_bio": "Biographie",
  "quiz.ui_demo.forms_label_locale": "Langue d'aperçu",
  "quiz.ui_demo.forms_label_name": "Nom affiché",
  "quiz.ui_demo.forms_label_upload": "Fichier de formation",
  "quiz.ui_demo.forms_placeholder_bio": "Texte de biographie court",
  "quiz.ui_demo.forms_placeholder_name": "Ada Lovelace",
  "quiz.ui_demo.forms_radio_a": "Option A",
  "quiz.ui_demo.forms_radio_b": "Option B",
  "quiz.ui_demo.forms_radio_legend": "Choisissez une option",
  "quiz.ui_demo.forms_select_de": "Allemand",
  "quiz.ui_demo.forms_select_en": "Anglais",
  "quiz.ui_demo.alert_error_body": "Corrigez les champs avant de continuer.",
  "quiz.ui_demo.alert_error_title": "Enregistrement impossible",
  "quiz.ui_demo.alert_info_body": "Les tâches peuvent prendre une minute.",
  "quiz.ui_demo.alert_info_title": "Information",
  "quiz.ui_demo.alert_success_body": "Le brouillon est enregistré.",
  "quiz.ui_demo.alert_success_title": "Enregistré",
  "quiz.ui_demo.alert_warn_body": "La taille du pool est proche du minimum.",
  "quiz.ui_demo.alert_warn_title": "Vérifier le pool",
  "quiz.ui_demo.caption_alert_error": "Alerte erreur",
  "quiz.ui_demo.caption_alert_info": "Alerte info",
  "quiz.ui_demo.caption_alert_success": "Alerte succès",
  "quiz.ui_demo.caption_alert_warning": "Alerte avertissement",
  "quiz.ui_demo.caption_badges": "Pastilles d'état",
  "quiz.ui_demo.caption_empty_demo": "État vide",
  "quiz.ui_demo.caption_loading_row": "Ligne de chargement",
  "quiz.ui_demo.caption_progress_demo": "Ligne de progression",
  "quiz.ui_demo.caption_table_demo": "Table simple",
  "quiz.ui_demo.display_badge_neutral": "Brouillon",
  "quiz.ui_demo.display_badge_success": "Prêt",
  "quiz.ui_demo.display_badge_warning": "En file d'attente",
  "quiz.ui_demo.display_empty_body": "Créez un quiz pour voir la liste.",
  "quiz.ui_demo.display_empty_title": "Aucun quiz",
  "quiz.ui_demo.display_progress_text": "Étape 2 sur 5 (démo).",
  "quiz.ui_demo.display_table_col_email": "Courriel",
  "quiz.ui_demo.display_table_col_state": "État",
  "quiz.ui_demo.display_table_row1_email": "a@example.com",
  "quiz.ui_demo.display_table_row1_state": "SENT",
  "quiz.ui_demo.display_table_row2_email": "b@example.com",
  "quiz.ui_demo.display_table_row2_state": "NOT_SENT",
  "quiz.ui_demo.loading_label": "Chargement des quiz...",
  "quiz.ui_demo.subheading_display": "Affichage des données",
  "quiz.ui_demo.subheading_feedback": "Alertes et chargement",
  "quiz.ui_demo.locale_picker_label": "Langue de l'interface",
  "quiz.ui_demo.caption_disclosure": "Bloc repliable",
  "quiz.ui_demo.caption_mc_option": "Tuiles à choix multiples",
  "quiz.ui_demo.caption_modal": "Fenêtre modale",
  "quiz.ui_demo.caption_pool_row": "Ligne du pool",
  "quiz.ui_demo.caption_reader": "Lecteur de formation",
  "quiz.ui_demo.domain_mc_opt_a": "Texte option A",
  "quiz.ui_demo.domain_mc_opt_b": "Texte option B",
  "quiz.ui_demo.domain_pool_meta": "4 choix · actif",
  "quiz.ui_demo.domain_pool_stem": "Quelle est la première étape de la liste ?",
  "quiz.ui_demo.domain_reader_sample":
    "Extrait : vérifiez l'identité avant d'accorder l'accès.",
  "quiz.ui_demo.overlay_disclosure_body":
    "Texte de politique replié par défaut.",
  "quiz.ui_demo.overlay_disclosure_summary": "Afficher les détails",
  "quiz.ui_demo.overlay_modal_body": "Dialogue natif pour les confirmations.",
  "quiz.ui_demo.overlay_modal_close": "Fermer",
  "quiz.ui_demo.overlay_modal_open": "Ouvrir la fenêtre de démo",
  "quiz.ui_demo.overlay_modal_title": "Fenêtre de démo",
  "quiz.ui_demo.subheading_domain": "Widgets quiz",
  "quiz.ui_demo.subheading_overlays": "Superpositions",
  "quiz.participant.answer_all":
    "Répondez à toutes les questions avant d'envoyer.",
  "quiz.participant.error_load":
    "L'invitation est peut-être invalide ou expirée. Utilisez le lien du dernier e-mail ou contactez l'organisateur.",
  "quiz.participant.error_missing_token":
    "Cette page nécessite un lien d'invitation complet avec son jeton.",
  "quiz.participant.error_title": "Impossible d'ouvrir ce lien",
  "quiz.participant.loading": "Chargement de votre devoir…",
  "quiz.participant.name_back_material": "Retour au support de formation",
  "quiz.participant.name_continue": "Continuer",
  "quiz.participant.name_heading": "Vos informations",
  "quiz.participant.name_hint":
    "Affiche dans le récapitulatif lorsque l'organisateur a prévu une étiquette pour les rapports.",
  "quiz.participant.name_intro":
    "Indiquez le nom que l'organisateur doit voir pour cette tentative.",
  "quiz.participant.name_label": "Votre nom",
  "quiz.participant.name_placeholder": "p. ex. Jordan Smith",
  "quiz.participant.name_required": "Saisissez votre nom pour continuer.",
  "quiz.participant.nav_back": "Retour",
  "quiz.participant.nav_next": "Suivant",
  "quiz.participant.abort_attempt": "Abandonner la tentative",
  "quiz.participant.abort_attempt_confirm":
    "Arrêter cette tentative ? Vos réponses seront ignorées. Si vous avez déjà terminé une tentative, vous verrez ce résultat à la place.",
  "quiz.participant.abort_attempt_aria":
    "Abandonner cette tentative de quiz sans envoyer les réponses",
  "quiz.participant.progress_label": "Question {current} sur {total}",
  "quiz.participant.question_heading": "Questions",
  "quiz.participant.resume_attempt": "Reprendre le quiz",
  "quiz.participant.result_failed": "Échec",
  "quiz.participant.result_passed": "Réussi",
  "quiz.participant.result_ident_quiz_label": "Quiz",
  "quiz.participant.result_ident_participant_label": "Terminé par",
  "quiz.participant.result_ident_participant_not_set": "Nom non indiqué",
  "quiz.participant.result_training_heading":
    "Documents de formation pour ce quiz",
  "quiz.participant.result_transcript_heading": "Ce que vous avez répondu",
  "quiz.participant.transcript_option_aria": "Votre choix {n} : {text}",
  "quiz.participant.transcript_question_correct": "Correct",
  "quiz.participant.transcript_question_wrong": "Incorrect",
  "quiz.participant.result_transcript_selection_note":
    "Les r\u00e9sultats d\u00e9taill\u00e9s par question ne sont pas disponibles dans cette vue. Ci-dessous figurent uniquement les options que vous avez choisies.",
  "quiz.participant.result_retry": "Recommencer",
  "quiz.participant.score_label": "Score : {percent}%",
  "quiz.participant.score_label_with_threshold":
    "Score : {percent}% \u2014 seuil de r\u00e9ussite {passPercent}%",
  "quiz.participant.skip_to_main": "Aller au contenu principal",
  "quiz.participant.start_attempt": "Démarrer le quiz",
  "quiz.participant.submit_assignment_issued":
    "Invitation envoy\u00e9e le {datetime}",
  "quiz.participant.submit_answers": "Envoyer les réponses",
  "quiz.participant.submitting": "Envoi…",
  "quiz.participant.training_intro":
    "Utilisez chaque lien pour enregistrer une copie du document avant de commencer.",
  "quiz.participant.training_resume_intro":
    "Vous avez déjà commencé ce quiz. Consultez les supports de formation une nouvelle fois si besoin, puis reprenez où vous vous êtes arrêté.",
  "quiz.participant.training_docs_empty":
    "Ce quiz ne comporte aucun document de formation pour l'instant.",
  "quiz.participant.training_doc_download_aria":
    "Télécharger le document de formation {filename}",
  "quiz.participant.training_heading": "Supports de formation",
};
